import { render, staticRenderFns } from "./detailPageLoader.vue?vue&type=template&id=b51bd080&scoped=true&"
import script from "./detailPageLoader.vue?vue&type=script&lang=js&"
export * from "./detailPageLoader.vue?vue&type=script&lang=js&"
import style0 from "./detailPageLoader.vue?vue&type=style&index=0&id=b51bd080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51bd080",
  null
  
)

export default component.exports